import type { RectangleXywh } from 'components/Graph/GraphApp/helpers/RectangleXywh';

export function overlays(
  rectangle1: RectangleXywh,
  rectangle2: RectangleXywh,
): boolean {
  return (
    rectangle1.x < rectangle2.x + rectangle2.width &&
    rectangle1.x + rectangle1.width > rectangle2.x &&
    rectangle1.y < rectangle2.y + rectangle2.height &&
    rectangle1.y + rectangle1.height > rectangle2.y
  );
}
